import React, { useState } from 'react';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import chrisb1 from '../../assets/images/chrisburgessshoot1.jpg';
import LoginModal from '../../components/loginSection/LoginModal';
import './About.css';

const About = () => {
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [activeDiscipline, setActiveDiscipline] = useState('clay');

    const openLoginModal = () => setIsLoginModalOpen(true);
    const closeLoginModal = () => setIsLoginModalOpen(false);

    const disciplines = [
        {
            id: 'clay',
            name: 'Clay Shooting',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <circle cx="12" cy="12" r="6"></circle>
                    <circle cx="12" cy="12" r="2"></circle>
                </svg>
            )
        },
        {
            id: 'game',
            name: 'Game Shooting',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 3L2 12h3v8h14v-8h3L12 3z"></path>
                    <path d="M9 21v-6h6v6"></path>
                </svg>
            )
        },
        {
            id: 'rifle',
            name: 'Rifle Shooting',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M2 12h6l2-3h4l2 3h6"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                    <path d="M12 9V6"></path>
                    <path d="M12 18v-3"></path>
                    <path d="M9 12H6"></path>
                    <path d="M18 12h-3"></path>
                </svg>
            )
        }
    ];

    const disciplineFeatures = {
        clay: {
            shooterFeatures: [
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <circle cx="12" cy="12" r="6"></circle>
                            <circle cx="12" cy="12" r="2"></circle>
                        </svg>
                    ),
                    title: 'Score Tracking',
                    description: 'Record scores for Sporting, Skeet, Trap, and all clay disciplines with detailed analytics.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                    ),
                    title: 'Squad Up',
                    description: 'Find shooting partners and join squads for practice sessions and competitions.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                    ),
                    title: 'Find Grounds',
                    description: 'Discover clay shooting grounds with stand layouts, trap types, and facilities.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                        </svg>
                    ),
                    title: 'Track Progress',
                    description: 'Monitor your improvement across different stands and target presentations.'
                }
            ],
            venueFeatures: [
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="3" y1="9" x2="21" y2="9"></line>
                            <line x1="9" y1="21" x2="9" y2="9"></line>
                        </svg>
                    ),
                    title: 'Stand Management',
                    description: 'QR code scoring on each stand with automatic leaderboard updates.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                    ),
                    title: 'Competition Days',
                    description: 'Organise registered shoots, club competitions, and open events.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="8.5" cy="7" r="4"></circle>
                            <line x1="20" y1="8" x2="20" y2="14"></line>
                            <line x1="23" y1="11" x2="17" y2="11"></line>
                        </svg>
                    ),
                    title: 'Member Management',
                    description: 'Track members, classifications, and competition history.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polygon points="23 7 16 12 23 17 23 7"></polygon>
                            <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
                        </svg>
                    ),
                    title: 'Ground Profile',
                    description: 'Showcase your stands, traps, and facilities with photos and videos.'
                }
            ]
        },
        game: {
            shooterFeatures: [
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 20V10"></path>
                            <path d="M18 20V4"></path>
                            <path d="M6 20v-4"></path>
                        </svg>
                    ),
                    title: 'Bag Recording',
                    description: 'Log your bag counts for pheasant, partridge, grouse, and all game species.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                    ),
                    title: 'Season Planner',
                    description: 'Plan your season with driven days, walked-up shoots, and wildfowling trips.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                    ),
                    title: 'Find Shoots',
                    description: 'Discover estates, syndicates, and let days across the country.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                    ),
                    title: 'Gun Line Community',
                    description: 'Connect with other guns, beaters, and pickers-up in your area.'
                }
            ],
            venueFeatures: [
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                    ),
                    title: 'Peg Management',
                    description: 'Map your pegs and drives with GPS positioning and descriptions.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                    ),
                    title: 'Day Bookings',
                    description: 'Manage driven days, let days, and syndicate calendars with ease.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="8.5" cy="7" r="4"></circle>
                            <line x1="20" y1="8" x2="20" y2="14"></line>
                            <line x1="23" y1="11" x2="17" y2="11"></line>
                        </svg>
                    ),
                    title: 'Gun & Team Lists',
                    description: 'Organise your guns, loaders, beaters, and pickers-up efficiently.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 20V10"></path>
                            <path d="M18 20V4"></path>
                            <path d="M6 20v-4"></path>
                        </svg>
                    ),
                    title: 'Season Statistics',
                    description: 'Track bags, bird counts, and season performance across all drives.'
                }
            ]
        },
        rifle: {
            shooterFeatures: [
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <circle cx="12" cy="12" r="6"></circle>
                            <circle cx="12" cy="12" r="2"></circle>
                        </svg>
                    ),
                    title: 'Precision Scoring',
                    description: 'Record scores for target rifle, F-Class, benchrest, and all rifle disciplines.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                        </svg>
                    ),
                    title: 'Group Analysis',
                    description: 'Track shot groups, MOA, and accuracy improvements over time.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                    ),
                    title: 'Find Ranges',
                    description: 'Locate rifle ranges with distance options, facilities, and availability.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                        </svg>
                    ),
                    title: 'Load Data',
                    description: 'Store and compare handload recipes and factory ammunition performance.'
                }
            ],
            venueFeatures: [
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="3" y1="9" x2="21" y2="9"></line>
                            <line x1="9" y1="21" x2="9" y2="9"></line>
                        </svg>
                    ),
                    title: 'Lane Booking',
                    description: 'Manage firing point bookings and range time slots efficiently.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                        </svg>
                    ),
                    title: 'Safety Management',
                    description: 'Track certifications, safety briefings, and range officer schedules.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                    ),
                    title: 'Competition Hosting',
                    description: 'Organise club shoots, open competitions, and league matches.'
                },
                {
                    icon: (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="8.5" cy="7" r="4"></circle>
                            <line x1="20" y1="8" x2="20" y2="14"></line>
                            <line x1="23" y1="11" x2="17" y2="11"></line>
                        </svg>
                    ),
                    title: 'Member Records',
                    description: 'Maintain member qualifications, scores, and classification records.'
                }
            ]
        }
    };

    const venueLabels = {
        clay: 'For Clubs & Grounds',
        game: 'For Estates & Shoots',
        rifle: 'For Ranges & Clubs'
    };

    const activeFeatures = disciplineFeatures[activeDiscipline];

    return (
        <div className="about-page">
            <Header openLoginModal={openLoginModal} />

            {/* Hero Section */}
            <section className="about-hero">
                <div className="about-hero-bg"></div>
                <div className="container">
                    <div className="about-hero-content">
                        <span className="about-badge">About Us</span>
                        <h1 className="about-hero-title">
                            The Platform Built<br />
                            <span>For All Shooters</span>
                        </h1>
                        <p className="about-hero-subtitle">
                            ShootConnect brings together passionate shooters across all disciplines - 
                            clay, game, and rifle - with powerful tools for tracking, connecting, and improving.
                        </p>
                    </div>
                </div>
            </section>

            {/* Discipline Tabs Section */}
            <section className="about-disciplines">
                <div className="container">
                    <div className="disciplines-header">
                        <h2>One Platform, All Disciplines</h2>
                        <p>Tailored features for every type of shooter and venue.</p>
                    </div>
                    
                    <div className="discipline-tabs">
                        {disciplines.map((discipline) => (
                            <button
                                key={discipline.id}
                                className={`discipline-tab ${activeDiscipline === discipline.id ? 'active' : ''}`}
                                onClick={() => setActiveDiscipline(discipline.id)}
                            >
                                <span className="discipline-tab-icon">{discipline.icon}</span>
                                <span className="discipline-tab-name">{discipline.name}</span>
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section className="about-features" key={activeDiscipline}>
                <div className="container">
                    {/* Shooter Features */}
                    <div className="features-block">
                        <div className="features-header">
                            <span className="features-badge features-badge-orange">For Shooters</span>
                            <h2>Everything You Need to Excel</h2>
                            <p>Powerful tools designed to help you track, improve, and share your shooting journey.</p>
                        </div>
                        <div className="features-grid">
                            {activeFeatures.shooterFeatures.map((feature, index) => (
                                <div key={index} className="feature-card feature-card-orange">
                                    <div className="feature-icon">{feature.icon}</div>
                                    <h4>{feature.title}</h4>
                                    <p>{feature.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Venue Features */}
                    <div className="features-block">
                        <div className="features-header">
                            <span className="features-badge features-badge-green">{venueLabels[activeDiscipline]}</span>
                            <h2>Grow Your {activeDiscipline === 'clay' ? 'Ground' : activeDiscipline === 'game' ? 'Shoot' : 'Range'}</h2>
                            <p>Professional tools to manage {activeDiscipline === 'game' ? 'guns, days,' : 'members, events,'} and showcase your facilities.</p>
                        </div>
                        <div className="features-grid">
                            {activeFeatures.venueFeatures.map((feature, index) => (
                                <div key={index} className="feature-card feature-card-green">
                                    <div className="feature-icon">{feature.icon}</div>
                                    <h4>{feature.title}</h4>
                                    <p>{feature.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Founder Section */}
            <section className="about-founder">
                <div className="container">
                    <div className="founder-grid">
                        <div className="founder-image-container">
                            <div className="founder-image-wrapper">
                                <img src={chrisb1} alt="Chris Burgess" />
                            </div>
                            <div className="founder-badge">Founder & CEO</div>
                        </div>
                        <div className="founder-content">
                            <span className="founder-label">Meet the Founder</span>
                            <h2>Chris Burgess</h2>
                            <p className="founder-intro">
                                With a passion for shooting sports and a tech-savvy background, Chris created 
                                ShootConnect to revolutionise how enthusiasts connect with each other and their sport.
                            </p>
                            <p>
                                Chris started with rough shoots and decoying pigeons, before his first taste of 
                                game shooting pheasants and ducks. Comfortable with shotgun and air rifle, he is 
                                happiest in a hide or at one of the many clay grounds in the UK.
                            </p>
                            <div className="founder-quote">
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
                                </svg>
                                <blockquote>
                                    "I wanted to create something that brings the shooting community together, 
                                    making it easier to find grounds, track improvement, and share the passion."
                                </blockquote>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mission Section */}
            <section className="about-mission">
                <div className="container">
                    <div className="mission-card">
                        <div className="mission-content">
                            <span className="mission-badge">Our Mission</span>
                            <h2>Advancing the Shooting Sports Community</h2>
                            <p>
                                We're committed to using technology to create more accessible, engaging, and 
                                efficient experiences for shooters and venues. Whether you're a competitive 
                                athlete, weekend clay shooter, game enthusiast, or running a range, ShootConnect 
                                provides the tools you need to succeed.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="about-cta">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Join the Community?</h2>
                        <p>Create your free account today and start your shooting journey with ShootConnect.</p>
                        <div className="cta-buttons">
                            <button onClick={openLoginModal} className="cta-btn-primary">
                                Get Started Free
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                    <polyline points="12 5 19 12 12 19"></polyline>
                                </svg>
                            </button>
                            <a href="/clubs" className="cta-btn-secondary">
                                Find a Venue
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <LoginModal isOpen={isLoginModalOpen} onClose={closeLoginModal} />
            <Footer />
        </div>
    );
};

export default About;
